<script>

import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js"
import {watch} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import {useAlarmStore} from "@/views/Notification/stores/Alarm.js";
import axios from "axios";

export default {
    name: "AlarmPage",
    setup() {
        const {loading, total, filter} = useSharedData();
        const {transformFilterValues} = useSharedMethod();
        const {$router, $i18n} = useTools();
        
        const alarmStore = useAlarmStore();
        const securityStore = useSecurityStore();
        
        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%"
            },
            {
                text: "Nom",
                sortable: false,
                align: "left",
                value: "name",
            },
        ];
        
        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_NOTIFICATION_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'alarms.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_NOTIFICATION_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'alarms.delete', params: {id: item.id}})
                },
            },
        ];
        
        function findAll() {
            loading.value = true;
            filter.value.allRecords = true;
            axios.get('/alarms', {params: transformFilterValues(filter.value)}).then((response) => {
                alarmStore.setAlarms(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function view(item) {
            $router.push({name: "alarms.view", params: {id: item.id}});
        }
        
        watch(filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});
        
        return {
            alarmStore,
            securityStore,
            headers,
            actions,
            loading,
            total,
            filter,
            findAll,
            view,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.notification')"
            :total="total"
        >
            <template #rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_NOTIFICATION_PARAM']"
                    :loading="loading"
                    @press="$router.push({ name: 'alarms.add' })"
                />
            </template>
            
            <template #content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="alarmStore.alarms"
                    sort-by="name"
                    root-path="alarms"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>